import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  Box,
  Typography,
  Autocomplete,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from '@mui/material';
import {
  Cancel,
  Error,
  HighlightOff,
  CheckCircle,
  CloudUpload,
  Update,
  KeyboardArrowDown
} from '@mui/icons-material';
import Dropzone from 'react-dropzone';
import { getClienteAtual } from 'shared';
import { mimeTypesArquivo, extensoesArquivo } from './Enums/EnumsTiposArquivos';
import BoxArquivo from './BoxArquivo';
import ButtonMain from './ButtonMain';
import { uploadDocumentoPadrao, deletarDocumentoPadrao } from '../../../api/onboarding';
import AlertErroMain from './AlertErroMain';
import { sanitizeFileName } from './Utils';

const DocumentoUpload = ({
  id,
  listaDocs,
  setListaDocs,
  boxClassesAdicionais,
  qtdMaximaArquivos,
  arquivosAceitos,
  tamanhoMaximoMegaAceito,
  isPending,
  setPending,
  funcaoUpload,
  funcaoDeletar,
  adicional = '',
  cnpjEmpresa = '',
  bloquearUpload = false,
  tipoComponente = 'completa',
  boxUploadAction = false,
  funcaoSalvarNovoDocumento = false,
  permitirDeletar = true,
  btnEnviarDocumento = true,
  inputObservacao = false,
  estadoUltimaPPC = '',
  qtdDocumentosAtualizados,
  renomearArquivoPorTipoDocumento = false
}) => {
  const [mostraErro, setMostraErro] = useState(false);
  const [modalSalvarNovoDocumento, setModalSalvarNovoDocumento] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [indexArquivo, setIndexArquivo] = useState(false);
  const [draggingFile, setDraggingFile] = useState(-1);
  const [pastedNovoDoc, setPastedNovoDoc] = useState(false);
  const [valueNovoDoc, setValueNovoDoc] = useState('');
  const [tipoNovoDoc, setTipoNovoDoc] = useState(false);
  const [configDropZone, setConfigDropZone] = useState({});
  const [mimeTypesAceitos, setMimeTypesAceitos] = useState([]);
  const [statusArquivo, setStatusArquivo] = useState({
    status: 'pendente',
    titulo_status: 'Pendente',
    subtitulo_status: ''
  });
  const [tamanhoResponsividade, setTamanhoResponsividade] = useState(5);
  const [textoInputObservacao, setTextoInputObservacao] = useState('');
  const [prontoParaEnviar, setProntoParaEnviar] = useState(false); // upload concluído e pronto para persistir

  const inputReference = useRef(null);
  const dropzoneOpenRef = useRef(null); // para abrir o seletor de arquivo pelo botão "Enviar"
  const cliente = getClienteAtual();
  const estaNaTelaDocSocio = sessionStorage.getItem('x-one7-tela-doc-socio');

  useEffect(() => {
    const configDropZoneTemp = {};
    let mimeTypesAceitosTemp = [];
    if (qtdMaximaArquivos && qtdMaximaArquivos !== 0) configDropZoneTemp.maxFiles = qtdMaximaArquivos;
    if (tamanhoMaximoMegaAceito && tamanhoMaximoMegaAceito !== 0) {
      configDropZoneTemp.maxSize = tamanhoMaximoMegaAceito * 1024 * 1024;
    }
    if (arquivosAceitos && arquivosAceitos.length !== 0) {
      configDropZoneTemp.accept = [];
      arquivosAceitos.map(tipo => {
        configDropZoneTemp.accept = configDropZoneTemp.accept.concat(extensoesArquivo[tipo]);
        mimeTypesAceitosTemp = mimeTypesAceitosTemp.concat(mimeTypesArquivo[tipo]);
        return tipo;
      });
      setConfigDropZone(configDropZoneTemp);
      setMimeTypesAceitos(mimeTypesAceitosTemp);
    }
    setTamanhoResponsividade(btnEnviarDocumento ? 5 : 6);
  }, []);

  useEffect(() => {
    listaDocs.map((doc, index) => {
      if (id === doc.id) setIndexArquivo(index);
      return doc;
    });
  }, [listaDocs, id]);

  useEffect(() => {
    if (
      indexArquivo !== false &&
      listaDocs[indexArquivo] &&
      listaDocs[indexArquivo].status !== undefined
    ) {
      const status = {
        status: listaDocs[indexArquivo].status,
        titulo_status: listaDocs[indexArquivo].titulo_status,
        subtitulo_status: listaDocs[indexArquivo].subtitulo_status
      };
      setStatusArquivo(status);
    } else if (
      indexArquivo !== false &&
      listaDocs[indexArquivo] &&
      (listaDocs[indexArquivo].hash_arquivo ||
        listaDocs[indexArquivo].link_arquivo ||
        listaDocs[indexArquivo].nome_arquivo)
    ) {
      setStatusArquivo({
        status: 'aprovado',
        titulo_status: 'Enviado',
        subtitulo_status: ''
      });
    } else {
      setStatusArquivo({
        status:
          listaDocs[indexArquivo] && listaDocs[indexArquivo].status
            ? listaDocs[indexArquivo].status
            : 'pendente',
        titulo_status:
          listaDocs[indexArquivo] && listaDocs[indexArquivo].titulo_status
            ? listaDocs[indexArquivo].titulo_status
            : 'Pendente',
        subtitulo_status:
          listaDocs[indexArquivo] && listaDocs[indexArquivo].subtitulo_status
            ? listaDocs[indexArquivo].subtitulo_status
            : ''
      });
    }
  }, [indexArquivo, listaDocs]);

  const filesAcceptedHandler = acceptedFiles => {
    setDraggingFile(-1);
    const cnpjEmp = listaDocs[indexArquivo].cnpj ? listaDocs[indexArquivo].cnpj : cnpjEmpresa;
    const acceptedFile = acceptedFiles[0];

    const extension = acceptedFile.name
      .split('.')
      .pop()
      .toLowerCase();
    const listaDocsTemp = [].concat(listaDocs);
    const cod_docNewReprovado = Number(String(valueNovoDoc).split(' ')[0]);
    const now = new Date();
    const isoTimestamp = now
      .toISOString()
      .replace(/[-:]/g, '')
      .replace('T', '_')
      .split('.')[0];

    let newFileName = '';
    if (renomearArquivoPorTipoDocumento) {
      const docAtual = listaDocsTemp[indexArquivo] || {};
      const nomeDocumentoBase =
        docAtual.nome_doc ||
        docAtual.nome ||
        (tipoNovoDoc && tipoNovoDoc.documento && tipoNovoDoc.documento.NOME) ||
        'documento';
      let nomeTipoDocumento = nomeDocumentoBase;

      const isFaturamento = String(nomeDocumentoBase)
        .toUpperCase()
        .includes('FATURAMENTO');
      if (isFaturamento) {
        const textoReferenciaMeses = `${docAtual.observacao_padrao || ''} ${docAtual.observacao ||
          ''} ${docAtual.observacao_doc || ''} ${docAtual.explicacao_doc || ''}`;
        const matchMeses = textoReferenciaMeses.match(/\b(12|24|36)\b/i);
        if (matchMeses && matchMeses[1]) {
          nomeTipoDocumento = `${nomeDocumentoBase} ${matchMeses[1]} MESES`;
        }
      }

      const prefixoNomeArquivo = sanitizeFileName(nomeTipoDocumento)
        .toLowerCase()
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '');

      const pad2 = value => String(value).padStart(2, '0');
      const timestamp =
        pad2(now.getDate()) +
        pad2(now.getMonth() + 1) +
        String(now.getFullYear()).slice(-2) +
        pad2(now.getHours()) +
        pad2(now.getMinutes()) +
        pad2(now.getSeconds());

      newFileName = `${prefixoNomeArquivo || 'documento'}_${timestamp}.${extension}`;
    } else {
      const nomeSemExtensao = acceptedFile.name.includes('.')
        ? acceptedFile.name.substring(0, acceptedFile.name.lastIndexOf('.'))
        : acceptedFile.name;
      const baseName = sanitizeFileName(nomeSemExtensao);
      newFileName = `${baseName}_${isoTimestamp}.${extension}`;
    }

    const renamedFile = new File([acceptedFile], newFileName, { type: acceptedFile.type });
    const limiteVencendo = cliente && cliente.limiteVencendo === 'S' ? 'S' : 'N';

    const dataFile = new FormData();
    dataFile.append('arquivo', renamedFile);
    dataFile.append('cnpj', cnpjEmp);
    dataFile.append('limiteVencendo', limiteVencendo);
    dataFile.append(
      'codTipoDocumento',
      listaDocsTemp[indexArquivo].cod_documento || cod_docNewReprovado || listaDocsTemp[indexArquivo].id
    );

    // mantém tipo/observação; só atualiza dados do arquivo
    listaDocsTemp[indexArquivo].nome_arquivo = newFileName;
    listaDocsTemp[indexArquivo].tamanho_arquivo = renamedFile.size;
    listaDocsTemp[indexArquivo].cpfcnpj = cnpjEmp;
    if (listaDocsTemp[indexArquivo].observacao_padrao) {
      listaDocsTemp[indexArquivo].observacao = listaDocsTemp[indexArquivo].observacao_padrao;
    } else if (listaDocsTemp[indexArquivo].observacao_doc) {
      listaDocsTemp[indexArquivo].observacao = listaDocsTemp[indexArquivo].observacao_doc;
    }
    delete listaDocsTemp[indexArquivo].status;
    delete listaDocsTemp[indexArquivo].titulo_status;
    delete listaDocsTemp[indexArquivo].subtitulo_status;
    setListaDocs(listaDocsTemp);

    setStatusArquivo({
      status: 'carregando',
      titulo_status: 'Carregando...',
      subtitulo_status: ''
    });

    let realizarUpload = uploadDocumentoPadrao;
    if (typeof funcaoUpload === 'function') {
      realizarUpload = funcaoUpload;
    }

    setPending(true);
    setLoadingUpload(0);
    setProntoParaEnviar(false); // reset antes do upload

    realizarUpload(dataFile, cnpjEmp, progressValue => {
      setLoadingUpload(progressValue - 30);
    })
      .then(res => {
        if (res.data) {
          if (res.data.path) {
            listaDocsTemp[indexArquivo].link_arquivo = res.data.path;
          }
          setListaDocs(listaDocsTemp);

          setLoadingUpload(75);
          setTimeout(() => {
            setLoadingUpload(90);
            setTimeout(() => {
              setLoadingUpload(100);
              setTimeout(() => {
                setPending(false);
                setLoadingUpload(false);
                setStatusArquivo({
                  status: 'aprovado',
                  titulo_status: 'Enviado',
                  subtitulo_status: ''
                });

                // upload concluiu -> habilita ação de "Enviar" (persistir no backend)
                setProntoParaEnviar(true);

                if (!btnEnviarDocumento) {
                  if (
                    typeof funcaoSalvarNovoDocumento === 'function' &&
                    tipoNovoDoc &&
                    tipoNovoDoc.documento
                  ) {
                    funcaoSalvarNovoDocumento(indexArquivo, tipoNovoDoc.documento);
                  }
                }
              }, 100);
            }, 300);
          }, 400);
        }
      })
      .catch(err => {
        acceptedFiles.response = err.response;
        acceptedFiles.statusCode = err.response && err.response.status ? err.response.status : 500;
        const retorno = err.response && err.response.data ? err.response.data : '';
        let erroConhecido = '';
        erroConhecido =
          retorno.exception && retorno.exception.indexOf('PostTooLargeException') !== -1
            ? 'Arquivo ultrapassa o tamanho máximo permitido'
            : erroConhecido;
        erroConhecido =
          retorno.errors && retorno.errors.arquivo && retorno.errors.arquivo[0]
            ? retorno.errors.arquivo[0]
            : erroConhecido;

        setStatusArquivo({
          status: 'reprovado',
          titulo_status: erroConhecido !== '' ? 'Pendente' : 'Erro ao enviar arquivo',
          subtitulo_status: erroConhecido !== '' ? erroConhecido : 'Favor contatar nosso suporte'
        });
        setLoadingUpload(false);
        setPending(false);
        setMostraErro(err.response);
        setProntoParaEnviar(false);
      });
  };

  const filesRejectedHandler = file => {
    setDraggingFile(-1);
    const rejectedFile = file[0];
    const _typeFile = rejectedFile.type;
    const _fileTypesAccepted = configDropZone.accept;
    const _extension = rejectedFile.name.split('.');
    const tamanhoMaximoBytesAceito = tamanhoMaximoMegaAceito * 1024 * 1024;
    let _errorMessage = 'Arquivo invalidado por erro desconhecido';
    if (_fileTypesAccepted.indexOf('.' + _extension[_extension.length - 1]) === -1) {
      _errorMessage =
        'O tipo de arquivo ' + _extension[_extension.length - 1].toUpperCase() + ' não é permitido';
    } else if (mimeTypesAceitos.indexOf(_typeFile) === -1) {
      _errorMessage = 'O tipo interno do arquivo não é permitido';
    } else if (rejectedFile.size > tamanhoMaximoBytesAceito) {
      _errorMessage = 'Arquivo ultrapassa o tamanho máximo de ' + tamanhoMaximoMegaAceito + 'MB';
    }

    setStatusArquivo({
      status: 'reprovado',
      titulo_status: 'Pendente',
      subtitulo_status: _errorMessage
    });
  };

  // Exclusão (mantendo comportamento, com limpeza dos campos do arquivo)
  const excluirDocumento = () => {
    if (typeof funcaoDeletar === 'function') {
      setPending(true);
      setLoadingUpload(10);

      const retorno = funcaoDeletar(listaDocs[indexArquivo].hash_arquivo, indexArquivo);

      Promise.resolve(retorno)
        .then(() => {
          removerArquivo(indexArquivo);
          setLoadingUpload(false);
          setPending(false);
        })
        .catch(err => {
          setStatusArquivo({
            status: 'reprovado',
            titulo_status: 'Erro ao deletar',
            subtitulo_status: 'Favor contatar nosso suporte'
          });
          setLoadingUpload(false);
          setPending(false);
          setMostraErro(err.response);
        });

      return true;
    }

    const deletarArquivo = deletarDocumentoPadrao;
    if (typeof funcaoDeletar === 'function') {
      funcaoDeletar(listaDocs[indexArquivo].hash_arquivo, indexArquivo);
      return true;
    }
    if (listaDocs[indexArquivo].hash_arquivo) {
      setPending(true);
      setLoadingUpload(10);
      setTimeout(() => {
        setLoadingUpload(50);
      }, 400);
      deletarArquivo(listaDocs[indexArquivo].hash_arquivo, indexArquivo)
        .then(() => {
          setLoadingUpload(75);
          setTimeout(() => {
            setLoadingUpload(100);
            setTimeout(() => {
              setPending(false);
              setLoadingUpload(false);
              removerArquivo(indexArquivo);
            }, 200);
          }, 400);
        })
        .catch(err => {
          setStatusArquivo({
            status: 'reprovado',
            titulo_status: 'Erro ao deletar',
            subtitulo_status: 'Favor contatar nosso suporte'
          });
          setLoadingUpload(false);
          setPending(false);
          setMostraErro(err.response);
        });
    } else {
      removerArquivo(indexArquivo);
    }
  };

  const removerArquivo = idx => {
    if (listaDocs[idx]) {
      const listaDocsTemp = [].concat(listaDocs);
      delete listaDocsTemp[idx].nome_arquivo;
      delete listaDocsTemp[idx].link_arquivo;
      delete listaDocsTemp[idx].tamanho_arquivo;
      delete listaDocsTemp[idx].hash_arquivo;
      setListaDocs(listaDocsTemp);
      setStatusArquivo({
        status: 'pendente',
        titulo_status: 'Pendente',
        subtitulo_status: ''
      });
      // após excluir, ainda não há upload novo; botão Enviar será mostrado por "semArquivo"
      setProntoParaEnviar(false);
    }
  };

  // Persiste no backend o mesmo documento (documento existente) com o novo arquivo já upado
  const enviarDocumentoAtual = () => {
    if (typeof funcaoSalvarNovoDocumento === 'function') {
      const item = listaDocs[indexArquivo] || {};
      const payloadTipo = {
        // ajuste os campos conforme o contrato da API:
        CODPPCDOCUMENTO: item.cod_documento,
        NOME: item.nome_doc,
        OBSERVACAO: item.observacao
      };
      funcaoSalvarNovoDocumento(indexArquivo, payloadTipo);
      setProntoParaEnviar(false);
      return;
    }
    setProntoParaEnviar(false);
  };

  const dropZoneEnter = indexArq => {
    if (draggingFile === -1 || draggingFile !== indexArq) {
      setDraggingFile(indexArq);
    }
  };

  const dropZoneLeave = () => {
    if (draggingFile !== -1) {
      setDraggingFile(-1);
    }
  };

  const handleOnChangeTipoDocNovoDoc = (ev, newValue) => {
    setValueNovoDoc(newValue && newValue.label ? newValue.label : '');
    if (
      typeof newValue === 'undefined' ||
      newValue === null ||
      newValue === 1 ||
      typeof newValue.documento === 'undefined' ||
      typeof newValue.documento.CODPPCDOCUMENTO === 'undefined'
    ) {
      setTipoNovoDoc(false);
      return;
    }
    setTipoNovoDoc(newValue);
  };

  const handleOnChangeObservacao = ev => {
    listaDocs.map(arquivo => {
      if (arquivo.id === id) {
        arquivo.observacao = ev.target.value;
      }
      return arquivo;
    });
    setTextoInputObservacao(ev.target.value);
  };

  const handleOnChangeInputTipoDocNovoDoc = event => {
    if (event && event.target) {
      let string = event && event.target && event.target.value ? event.target.value : '';
      if (event) {
        if (pastedNovoDoc) {
          string = string
            .replaceAll('.', '')
            .replace('/', '')
            .replace('-', '');
        }
      }
      setValueNovoDoc(string);
    }
    setPastedNovoDoc(false);
  };

  const handlePasteTipoDocNovoDoc = () => {
    setPastedNovoDoc(true);
  };

  const corTextoStatus = {
    aprovado: 'texto-success',
    pendente: 'texto-warning',
    analise: 'texto-warning',
    carregando: 'texto-warning',
    reprovado: 'texto-danger'
  };

  const iconeStatus = {
    aprovado: <CheckCircle sx={{ mr: '14px', mt: '-7px' }} />,
    pendente: <Error sx={{ mr: '14px', mt: '-7px' }} />,
    analise: <Error sx={{ mr: '14px', mt: '-7px' }} />,
    carregando: <Update sx={{ mr: '14px', mt: '-7px' }} />,
    reprovado: <Cancel sx={{ mr: '14px', mt: '-7px' }} />
  };

  const clickBoxUpload = () => {
    if (boxUploadAction !== false && typeof boxUploadAction === 'function') {
      boxUploadAction(indexArquivo, listaDocs[indexArquivo]);
    }
  };

  const cancelarNovoDoc = () => {
    if (listaDocs[indexArquivo].id === 'new_doc') {
      const listaDocsTemp = [].concat(listaDocs);
      listaDocsTemp.splice(indexArquivo, 1);
      setListaDocs(listaDocsTemp);
    }
  };

  // quando NÃO bloqueia por limite, simula Confirmar do outro modal
  const onAcaoSemBloqueio = () => {
    if (
      listaDocs[indexArquivo] &&
      listaDocs[indexArquivo].id === 'new_doc' &&
      typeof funcaoSalvarNovoDocumento === 'function' &&
      tipoNovoDoc &&
      tipoNovoDoc.documento
    ) {
      funcaoSalvarNovoDocumento(indexArquivo, tipoNovoDoc.documento);
      setModalSalvarNovoDocumento(false);
      return;
    }
    setListaDocs([].concat(listaDocs)); // força rerender
  };

  // ======= DERIVAÇÃO DE VISIBILIDADE DO BOTÃO =======
  const itemAtual = indexArquivo !== false && listaDocs[indexArquivo] ? listaDocs[indexArquivo] : null;
  const semArquivo =
    !!itemAtual &&
    typeof itemAtual.nome_arquivo === 'undefined' &&
    typeof itemAtual.hash_arquivo === 'undefined' &&
    typeof itemAtual.link_arquivo === 'undefined';

  // mostra Enviar quando: (a) sem arquivo (após excluir ou inicial) OU (b) upload concluído e pronto para enviar
  const mostrarBotaoEnviar = !!btnEnviarDocumento && (semArquivo || prontoParaEnviar);

  return (
    <Box
      key={'doc_up_' + id}
      id={'doc-focus-' + id + String(adicional)}
      className={'borda-bottom-2 ' + String(boxClassesAdicionais)}
      sx={{ pb: '25px', pt: '25px' }}
      onClick={clickBoxUpload}
    >
      {indexArquivo !== false && listaDocs[indexArquivo] && (
        <Grid container spacing={2} className="items-centro-verticalmente">
          {listaDocs[indexArquivo].id === 'new_doc' ? (
            <>
              <Grid item xl={1} lg={1} md={1} sm={12} xs={12} className="flex-box-items-centralizados">
                <IconButton title="Cancelar Inclusão de Novo Documento" onClick={cancelarNovoDoc}>
                  <HighlightOff className="texto-cor-cinza-2 link-texto" />
                </IconButton>
              </Grid>
              <Grid
                item
                xl={tamanhoResponsividade}
                lg={tamanhoResponsividade}
                md={tamanhoResponsividade}
                sm={12}
                xs={12}
              >
                <Autocomplete
                  disablePortal
                  id="novo_tipoDocumento"
                  onChange={handleOnChangeTipoDocNovoDoc}
                  className="combobox_principal"
                  popupIcon={
                    <KeyboardArrowDown className="texto-cor-complementar w-1-5em font-size-2rem" />
                  }
                  onInputChange={handleOnChangeInputTipoDocNovoDoc}
                  inputValue={valueNovoDoc}
                  onPaste={handlePasteTipoDocNovoDoc}
                  options={
                    listaDocs[indexArquivo].novo_doc_lista
                      ? listaDocs[indexArquivo].novo_doc_lista.map((item, index) => {
                          return {
                            label: parseInt(index + 1, 10) + ' - ' + item.NOME,
                            documento: item
                          };
                        })
                      : []
                  }
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  autoHighlight
                  renderInput={params => (
                    <TextField
                      autoFocus
                      inputRef={inputReference}
                      {...params}
                      label="Escolha o tipo do documento"
                    />
                  )}
                  disabled={isPending}
                  noOptionsText="Nenhum tipo encontrado"
                />
              </Grid>
            </>
          ) : tipoComponente === 'completa' ? (
            <Grid item xl={7} lg={7} md={7} sm={12} xs={12}>
              <Typography
                variant="h6"
                className={(corTextoStatus[statusArquivo.status] || '') + ' texto-negrito'}
              >
                {iconeStatus[statusArquivo.status]}
                {statusArquivo.titulo_status}
              </Typography>
              {statusArquivo.subtitulo_status !== '' && (
                <Typography variant="subtitle1" className={corTextoStatus[statusArquivo.status] || ''}>
                  {statusArquivo.subtitulo_status}
                </Typography>
              )}
              <Typography variant="h6" className="texto-negrito texto-cor-cinza-escuro">
                {listaDocs[indexArquivo].nome_doc}
              </Typography>
              <Typography variant="subtitle1" className="texto-cor-cinza-escuro">
                {listaDocs[indexArquivo].obrigacao_doc ? '(obrigatório)' : '(opcional)'}
              </Typography>
              <Typography variant="subtitle1" className="texto-cor-cinza-escuro">
                {listaDocs[indexArquivo].explicacao_doc
                  ? listaDocs[indexArquivo].explicacao_doc.charAt(0).toUpperCase() +
                    listaDocs[indexArquivo].explicacao_doc.substr(1).toLowerCase()
                  : '---'}
              </Typography>
            </Grid>
          ) : listaDocs[indexArquivo].nome_doc ? (
            <Grid
              item
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="flex items-centro-verticalmente flex-direction-column"
            >
              <Typography
                variant="subtitle1"
                className="texto-negrito texto-cor-cinza-escuro"
                sx={{ ml: '60px' }}
              >
                {listaDocs[indexArquivo].nome_doc}
              </Typography>
              <Typography variant="subtitle1" className="texto-cor-cinza-claro" sx={{ ml: '60px' }}>
                {listaDocs[indexArquivo].observacao_doc}
              </Typography>
            </Grid>
          ) : null}

          <Grid className="component-arquivo-upload" item xl={5} lg={5} md={5} sm={12} xs={12}>
            <Box
              key={'arq_up_' + id}
              className={
                (listaDocs[indexArquivo].nome_arquivo === undefined
                  ? 'texto-centro borda-2-width ' +
                    (draggingFile === indexArquivo
                      ? 'borda-dashed borda-cor-principal'
                      : 'borda-dotted borda-cor-cinza')
                  : 'borda-1 borda-cor-cinza ' +
                    (loadingUpload ? 'fundo-cor-cinza-claro-2' : 'box-shadow-natural-5')) +
                ' border-radius-8 w-100 box-upload fundo-cor-branca'
              }
            >
              {listaDocs[indexArquivo].nome_arquivo === undefined ? (
                <Dropzone
                  onDropAccepted={filesAcceptedHandler}
                  onDropRejected={filesRejectedHandler}
                  disabled={
                    isPending ||
                    loadingUpload !== false ||
                    bloquearUpload ||
                    (listaDocs[indexArquivo].id === 'new_doc' && !tipoNovoDoc && !btnEnviarDocumento)
                  }
                  onDragEnter={() => dropZoneEnter(indexArquivo)}
                  onDragLeave={dropZoneLeave}
                  noDrag={false}
                  multiple={false}
                  {...configDropZone}
                >
                  {({ getRootProps, getInputProps, open }) => {
                    // expõe a função open() para o botão externo "Enviar"
                    dropzoneOpenRef.current = open;
                    return (
                      <Box
                        {...getRootProps()}
                        className={loadingUpload === false ? 'cursor-pointer' : 'pointer-events-none'}
                        sx={
                          tipoComponente === 'completa'
                            ? { p: '15px 30px', minHeight: '110px' }
                            : { p: '5px 15px' }
                        }
                      >
                        <input {...getInputProps()} />
                        {tipoComponente === 'completa' && (
                          <CloudUpload
                            className="texto-cor-cinza-claro w-100 font-size-2-5rem"
                            sx={{ mb: '15px' }}
                          />
                        )}
                        <Typography
                          variant="subtitle1"
                          className="texto-cor-cinza-claro font-size-0-875rem w-100"
                        >
                          Arraste e solte seu arquivo aqui
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          className="texto-cor-cinza-claro font-size-0-875rem w-100"
                        >
                          ou
                        </Typography>
                        <Typography variant="subtitle1" className="texto-link w-100">
                          Procurar arquivos
                        </Typography>
                      </Box>
                    );
                  }}
                </Dropzone>
              ) : (
                <Box
                  className="flex-box items-esquerda items-meio margin-zero"
                  sx={{ minHeight: '110px' }}
                >
                  <BoxArquivo
                    file={listaDocs[indexArquivo]}
                    funcaoDeletar={excluirDocumento}
                    loadingUpload={loadingUpload}
                    isPending={isPending}
                    tipoComponente={tipoComponente}
                    permitirDeletar={permitirDeletar}
                    onAcaoSemBloqueio={onAcaoSemBloqueio}
                    estadoUltimaPPC={estadoUltimaPPC}
                    documentosAtualizados={qtdDocumentosAtualizados}
                  />
                </Box>
              )}
            </Box>
          </Grid>

          {!['FIM', 'INA'].includes(estadoUltimaPPC) &&
          mostrarBotaoEnviar &&
          estaNaTelaDocSocio !== 'documentosocio' ? (
            <Grid item xl={1} lg={1} md={1} sm={12} xs={12} className="flex-box-items-centralizados">
              <ButtonMain
                tipoBotao="azul-escuro"
                disabled={isPending}
                onClick={() => {
                  // Caso 1: SEM ARQUIVO -> abrir seletor para escolher novo arquivo
                  if (semArquivo) {
                    // documento existente (não-new_doc): abre seletor diretamente
                    if (listaDocs[indexArquivo].id !== 'new_doc') {
                      if (dropzoneOpenRef.current) dropzoneOpenRef.current();
                      return;
                    }
                    // fluxo NEW_DOC exige tipo escolhido
                    if (
                      tipoNovoDoc &&
                      tipoNovoDoc.documento &&
                      typeof tipoNovoDoc.documento.CODPPCDOCUMENTO !== 'undefined'
                    ) {
                      if (dropzoneOpenRef.current) dropzoneOpenRef.current();
                      setDraggingFile(indexArquivo);
                      setTimeout(() => setDraggingFile(-1), 500);
                    } else {
                      if (inputReference && inputReference.current) inputReference.current.focus();
                    }
                    return;
                  }

                  // Caso 2: COM ARQUIVO NOVO pronto -> persistir
                  if (prontoParaEnviar) {
                    // Para NEW_DOC, mantém modal de confirmação
                    if (listaDocs[indexArquivo].id === 'new_doc') {
                      setModalSalvarNovoDocumento(true);
                      return;
                    }
                    // Documento existente: salva direto
                    enviarDocumentoAtual();
                    return;
                  }
                }}
              >
                Enviar
              </ButtonMain>
            </Grid>
          ) : (
            tipoComponente !== 'completa' && (
              <Grid item xl={1} lg={1} md={1} sm={12} xs={12} className="flex-box-items-centralizados">
                <Typography
                  variant="h6"
                  className={(corTextoStatus[statusArquivo.status] || '') + ' texto-negrito'}
                  title={statusArquivo.subtitulo_status}
                >
                  {iconeStatus[statusArquivo.status]}
                </Typography>
              </Grid>
            )
          )}

          {listaDocs[indexArquivo].nome_arquivo !== undefined &&
            statusArquivo.status === 'aprovado' &&
            inputObservacao && (
              <TextField
                key={'input-observacao-upload-' + id}
                id={'input-observacao-upload-' + id}
                name={'input-observacao-upload-' + id}
                variant="outlined"
                label="Observação"
                className="input-observacao-upload"
                value={
                  [
                    'FATURAMENTO DOS ÚLTIMOS 12 MESES',
                    'FATURAMENTO DOS ÚLTIMOS 24 MESES',
                    'FATURAMENTO DOS ÚLTIMOS 36 MESES'
                  ].indexOf(listaDocs[indexArquivo].explicacao_doc) !== -1
                    ? listaDocs[indexArquivo].explicacao_doc
                    : textoInputObservacao
                }
                onChange={handleOnChangeObservacao}
                multiline
                maxRows={2}
                inputProps={{ maxLength: 250 }}
              />
            )}
        </Grid>
      )}

      <AlertErroMain exibeErro={mostraErro} escondeErro={setMostraErro} />

      {/* Modal de confirmação de envio (fluxo existente para NEW_DOC) */}
      <Dialog
        open={modalSalvarNovoDocumento !== false}
        keepMounted
        onClose={() => setModalSalvarNovoDocumento(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="texto-cor-principal texto-negrito">
          Envio de documento
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Ao confirmar esta ação o arquivo será enviado para análise e não poderá ser alterado. Você
            quer mesmo continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid container>
            <Grid item xl={6} lg={6} md={4} sm={2} />
            <Grid item xl={3} lg={3} md={4} sm={5} xs={6}>
              <ButtonMain tipoBotao="transparente" onClick={() => setModalSalvarNovoDocumento(false)}>
                Cancelar
              </ButtonMain>
            </Grid>
            <Grid item xl={3} lg={3} md={4} sm={5} xs={6}>
              <ButtonMain
                tipoBotao="azul-escuro"
                onClick={() => {
                  if (
                    typeof funcaoSalvarNovoDocumento === 'function' &&
                    tipoNovoDoc &&
                    tipoNovoDoc.documento
                  ) {
                    funcaoSalvarNovoDocumento(indexArquivo, tipoNovoDoc.documento);
                  }
                  setModalSalvarNovoDocumento(false);
                }}
              >
                Confirmar
              </ButtonMain>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DocumentoUpload;
